import { GET_ORDER, GET_ORDERS_BY_FILTER, CLEAR_ORDERS, GET_RELATED_ORDERS } from '../constants/action-types';
import { OrderQueueOriginType } from '../constants/OrderQueueOriginType';

// INITIALIZE STATE
const initialState = {
    orders: {},
    relatedOrders: {},
    orderCount: 0
};

// REDUCER
export const OrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORDER: {
            const incomingOrders = action.payload.messages;
            const orderCount = action.payload.messages.length;
            const orders = {};

            incomingOrders.forEach(order => {
                let data = order.payload
                if (data != null) {
                    const type = order.type

                    if (order.type !== OrderQueueOriginType.Order) {
                        try {
                            data = JSON.parse(data)
                        } catch (e) {
                            console.log("Failed to parse :", data);
                        }
                    }

                    const newOrder = {
                        data: data,
                        type: type
                    }
                    orders[`${newOrder.data.id}+${order.type}`] = newOrder;
                }
            });

            return {
                ...state,
                orders: orders,
                orderCount: orderCount
            }
        }

        case GET_ORDERS_BY_FILTER: {
            const incomingOrders = action.payload.orderModels;
            const orderCount = action.payload.count;
            const orders = {};

            incomingOrders.forEach((order) => {
                const newOrder = {
                    data: order,
                    type: "Order"
                }
                orders[order.id] = newOrder;
            });

            return {
                ...state,
                orders: orders,
                orderCount: orderCount
            }
        }

        case GET_RELATED_ORDERS: {
            const incomingOrders = action.payload.messages;
            const orderId = action.payload.orderId
            const orders = {};

            incomingOrders.forEach(order => {
                let data = order.payload
                if (data != null) {
                    const type = order.type

                    if (order.type === OrderQueueOriginType.Order && (data.OrderId == orderId || data.MiddleWareId == orderId)) {
                        const newOrder = {
                            data: data,
                            type: type
                        }
                        orders[`${newOrder.data.id}+${order.type}`] = newOrder;
                    }
                }
            });

            return {
                ...state,
                relatedOrders: orders
            }
        }

        case CLEAR_ORDERS: {
            const orders = {}
            const currentOrder = {}
            const orderCount = 50

            return {
                ...state,
                orders,
                currentOrder,
                orderCount
            }
        }

        default:
            return state;
    }
};